import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_storage_racks: FaireCategoryEntity = {
  token: "cat_storage-racks",
  type: "category",
  name: "Racks & shelves",
  level: 3,
  parentToken: "cat_home-decor-storage",
  href: "/category/home-decor/storage-organization/racks-shelves",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
